<script setup>
import MysticPotion from '@/assets/images/mystic.png';
import Pinata from '@/assets/images/pinata.png';
import Zombie from '@/assets/images/Zombie.png';
import Tesouro from '@/assets/images/tesouro.png';
import Jelly from '@/assets/images/jelly.png';
import Baloot from '@/assets/images/Baloot.png';
import Okey from '@/assets/images/okey.png';

import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm']);

const handleConfirm = () => {
  emit('confirm');
};

const moreApps = [
  {
    name: 'Mystic Potion',
    icon: MysticPotion,
    version: '1.0.1',
  },
  {
    name: 'Pinata Wins',
    icon: Pinata,
    version: '1.0.0',
  },
  {
    name: 'Zombie Outbreak',
    icon: Zombie,
    version: '1.0.2',
  },
];

const likeApps = [
  {
    name: 'Tesouro Slots',
    icon: Tesouro,
    version: '2.0.1',
  },
  {
    name: 'Jelly Boom Slots',
    icon: Jelly,
    version: '2.0.2',
  },
  {
    name: 'Baloot',
    icon: Baloot,
    version: '3.2.0',
  },
  {
    name: 'Okey 101',
    icon: Okey,
    version: '1.2.0',
  },
];
</script>
<template>
  <div class="ios-moreapps">
    <div class="title">
      <h2>
        {{ info.language_list.moreby }}&nbsp;&nbsp;{{ info.author }}
        <i class="iconfont icon-fanye"></i>
      </h2>
    </div>
    <div class="applist">
      <div
        v-for="(item, index) in moreApps"
        :key="index"
        class="app-item flex"
        @click="handleConfirm">
        <img :src="item.icon" />

        <div class="flex justify-between align-center app-info">
          <div>
            <div class="app-name">{{ item.name }}</div>
            <div class="app-version">{{info.language_list.version}}&nbsp;&nbsp;{{ item.version }}</div>
          </div>
          <div>
            <div class="get-btn">{{ info.language_list.get }}</div>
            <div class="app-buy">{{ info.language_list.inapp }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="title">
      <h2>
        {{ info.language_list.like }}
        <i class="iconfont icon-fanye"></i>
      </h2>
    </div>
    <div class="applist">
      <div
        v-for="(item, index) in likeApps"
        :key="index"
        class="app-item flex"
        @click="handleConfirm">
        <img :src="item.icon" />

        <div class="flex justify-between align-center app-info">
          <div>
            <div class="app-name">{{ item.name }}</div>
            <div class="app-version">{{info.language_list.version}}&nbsp;&nbsp;{{ item.version }}</div>
          </div>
          <div>
            <div class="get-btn">{{ info.language_list.get }}</div>
            <div class="app-buy">{{ info.language_list.inapp }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.ios-moreapps {
  color: #000;
  padding-bottom: 100px;
  .title {
    h2 {
      margin: 20px 0 8px 0;
    }
    .iconfont {
      color: #000;
    }
  }
  .applist {
    .app-item {
      margin-top: 10px;
    }
    img {
      width: 48px;
      height: 48px;
      border-radius: 6px;
      margin-right: 10px;
    }
    .app-name {
      color: #333333;
    }
    .app-version {
      color: #666666;
      font-size: 10px;
    }
    .app-info {
      border-bottom: 1px solid #ddd;
      padding-bottom: 18px;
      flex-grow: 1;
    }
    .get-btn {
      width: 64px;
      height: 23px;
      line-height: 23px;
      border-radius: 157px;
      background: #e6e6e6;
      text-align: center;
      color: var(--main-color);
      font-size: 12px;
    }
    .app-buy {
      font-size: 8px;
      color: #999;
      text-align: center;
    }
  }
}
</style>
